import apiClient from './apiClient';
import { IntegrationCredentialSummary, IntegrationCredentialInput, IntegrationProvider } from '../types/integrationCredentials';

/** O que a tela precisa saber sobre o provisionamento desta empresa no Clube Lidera. */
export interface SituacaoNoClubeLidera {
  integracaoLigada: boolean;
  empresaTemEmail: boolean;
  cnpjValido: boolean;
  ativos: number;
  /** Ativos que ficam de fora do lote por não terem e-mail. */
  semEmail: Array<{ id: string; nome: string }>;
  pronto: boolean;
  impedimentos: string[];
  ultimoEnvio: {
    status: 'enviado' | 'nao_enviado' | 'falhou' | null;
    em: string | null;
    detalhe: string | null;
  };
}

class IntegrationCredentialsService {
  private baseUrl(companyId: string): string {
    return `/companies/${companyId}/integration-credentials`;
  }

  async list(companyId: string): Promise<IntegrationCredentialSummary[]> {
    const response = await apiClient.get(this.baseUrl(companyId));
    return response.data ?? [];
  }

  async save(
    companyId: string,
    provider: IntegrationProvider,
    input: IntegrationCredentialInput
  ): Promise<IntegrationCredentialSummary> {
    const response = await apiClient.put(`${this.baseUrl(companyId)}/${provider}`, input);
    return response.data;
  }

  /** Liga/desliga a integração sem apagar a credencial — o segredo é write-only e não voltaria. */
  async setActive(
    companyId: string,
    provider: IntegrationProvider,
    active: boolean
  ): Promise<IntegrationCredentialSummary> {
    const response = await apiClient.patch(`${this.baseUrl(companyId)}/${provider}/active`, {
      active,
    });
    return response.data;
  }

  async clubeLidera(companyId: string): Promise<SituacaoNoClubeLidera> {
    const response = await apiClient.get(`/companies/${companyId}/clube-lidera`);
    return response.data as SituacaoNoClubeLidera;
  }

  async remove(companyId: string, provider: IntegrationProvider): Promise<void> {
    await apiClient.delete(`${this.baseUrl(companyId)}/${provider}`);
  }
}

export const integrationCredentialsService = new IntegrationCredentialsService();
export default integrationCredentialsService;
